export const TOP = "actionBar--top";
export const BOTTOM = "actionBar--bottom";
export const LEFT = "actionBar--left";
export const RIGHT = "actionBar--right";
export const RIGHT_BOTTOM = "actionBar--rightBottom";
export const RIGHT_TOP = "actionBar--rightTop";
export const TOP_RIGHT = "actionBar--top-right";